import type {
  FooterVariant,
  FooterNavigationGroup,
  FooterLink,
  HeaderVariant,
  NavigationMenus,
  MainLogoVariant,
} from '../entities';
import { getGlobalConfigByDomain, getGlobalConfigByLocale } from './config';
import { LocaleType } from '@benzinga/translate';
import { DOMAINS, DomainType } from '../entities';

export const getMenuByLocale = (
  locale: LocaleType,
  menu: string,
): FooterNavigationGroup[] | NavigationMenus | FooterLink[] | null => {
  const globalConfig = getGlobalConfigByLocale(locale);

  if (globalConfig?.menu?.[menu]) {
    return globalConfig.menu[menu];
  }

  return null;
};

export const getHeaderVariantByLocale = (locale: LocaleType): HeaderVariant => {
  const globalConfig = getGlobalConfigByLocale(locale);

  return globalConfig?.headerVariant || 'default';
};

export const getFooterVariantByLocale = (locale: LocaleType): FooterVariant => {
  const globalConfig = getGlobalConfigByLocale(locale);

  return globalConfig?.footerVariant || 'default';
};

export const getLogoVariantByLocale = (locale: LocaleType): MainLogoVariant => {
  const globalConfig = getGlobalConfigByLocale(locale);

  return globalConfig?.logoVariant || 'default';
};

export const getLogoVariantByDomain = (domain: DomainType): MainLogoVariant => {
  const globalConfig = getGlobalConfigByDomain(domain);

  return globalConfig?.logoVariant || 'default';
};

export const getGlobalLogoVariant = (host: string, locale: LocaleType): MainLogoVariant => {
  const domain = host?.split('.')?.[0] ?? 'www';

  if (Object.values(DOMAINS).includes(domain as DOMAINS)) {
    return getLogoVariantByDomain(domain as DOMAINS);
  } else {
    return getLogoVariantByLocale(locale);
  }
};
